import { render, staticRenderFns } from "./intercom.vue?vue&type=template&id=653d0710"
import script from "./intercom.vue?vue&type=script&lang=js"
export * from "./intercom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports